<!--* *
* loader is a root component
* *-->
<app-loader></app-loader>


<!--* *
* load dfx mobile im component
* *-->
<app-dfxmobileim></app-dfxmobileim>